<script>
    import {ORDER_STATUS, PASSPORT_STATUS} from "../lib/constants";
    import {countPassports, passportStatus} from "../lib/lib";
    import passportsStore from "../stores/passportsStore";
    // import PassportCreateModal from "../passports/PassportCreateModal.svelte";
    import OrderPassportsModal from "./OrderPassportsModal.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    // import AppIcon from "../components/icons/AppIcon.svelte";
    // import Alert from "../stores/alerts";

    export let maxQuantity = 0;
    export let statusId = null;
    export let passports = [];

    let availableQuantity = 0;
    let returnPassports = 0;
    let allPassportsStatus = null;
    let showPassports = false;

    const initPassports = () => {
        availableQuantity = maxQuantity;
        passports.map(item => {
            if (item.old_status === undefined) {
                item.old_status = item.status;
            }
            // if (!item.is_deleted) {
                availableQuantity -= ~~item.total;
            // }
            allPassportsStatus = item.status;
        })
    }

    const openPassports = () => {
        showPassports = true;
    }

    const closePassports = param => {
        showPassports = false;
        if (param) {
            param.total = countPassports(param.passport_from, param.passport_to);
            passports = [...passports, param];
            initPassports();
            // showStatusNew = false;
        }
    }

    // const onDelete = (index) => {
    //     Alert.delete("Αφαίρεση διαβατηρίων", "Να αφαιρεθούν τα διαβατήρια;", deletePassports(index));
    // }
    //
    // const deletePassports = index => {
    //     passports[index].is_deleted = 1;
    //     initPassports();
    //     // passports.splice(index, 1);
    // }

    const onReturnPassportsChange = () => {
        console.log("onReturnPassportsChange", returnPassports);
        passports.map(chunk => {
            if (returnPassports) {
                if (chunk.status == PASSPORT_STATUS.ASSIGNED) {
                    chunk.status = PASSPORT_STATUS.RETURN;
                }
            } else {
                chunk.status = chunk.old_status;
            }
        });
        passports = passports;
    }

    // initialize
    initPassports();
</script>

{#if statusId != ORDER_STATUS.NEW}
    {#if passports.length}
        <div class="legend py-1 mb-1">
            Αρ. Διαβατηρίων
        </div>
        {#each passports as chunk, index}
            <!--{#if !chunk.is_deleted}-->
                <div class="passports-row mb-2">
                    <div class="mb-1" class:text-danger={ chunk.status == PASSPORT_STATUS.RETURNED || chunk.status == PASSPORT_STATUS.DESTROYED }>
                        { passportStatus(chunk.status) }
                    </div>
                    <div class="passports">
                        <div class="form-control input-info form-item">
                            { $passportsStore.prefix }{ chunk.passport_from }
                            <div class="form-item-info top">Από</div>
                        </div>
                        <div class="form-control input-info form-item">
                            { $passportsStore.prefix }{ chunk.passport_to }
                            <div class="form-item-info top">Έως</div>
                        </div>
                        <!--                        <button class="btn btn-default delete" title="διαγραφή"-->
                        <!--                                on:click={ () => onDelete(index) }-->
                        <!--                                disabled="{ chunk.status != PASSPORT_STATUS.ASSIGN }">-->
                        <!--                            <AppIcon icon="x" size="18"/>-->
                        <!--                        </button>-->
                    </div>
                </div>
            <!--{/if}-->
        {/each}
        {#if (statusId == ORDER_STATUS.RETURNED || statusId == ORDER_STATUS.CANCELED) && allPassportsStatus == PASSPORT_STATUS.ASSIGNED}
            <Checkbox label="Να επιστραφούν τα διαβατήρια της παραγγελίας"
                      bind:checked="{ returnPassports }" on:change={ onReturnPassportsChange } cssClass="mt-3"/>
        {/if}
    {/if}
    {#if availableQuantity > 0}
        <button class="btn btn-default btn-block" on:click={ openPassports }>
            ΟΡΙΣΜΟΣ ΔΙΑΒΑΤΗΡΙΩΝ
        </button>
    {/if}
{/if}

{#if showPassports}
    <OrderPassportsModal passportQuantity="{ availableQuantity }"
                         autofillPassports={ passports.length == 0}
                         closeCallback="{ closePassports }"/>
{/if}

<style>
    /*.passports-row {*/

    /*}*/

    .passports-row .passports {
        display: flex;
        align-items: center;
    }

    .passports-row .passports .form-control {
        /*width: calc(50% - 15px);*/
        width: 50%;
        margin-right: 5px;
    }

    /*.passports-row .passports .delete {*/
    /*    width: 30px;*/
    /*    height: 38px;*/
    /*    padding-left: 0;*/
    /*    padding-right: 0;*/
    /*}*/

    /*.passports-row .status {*/

    /*}*/
</style>
